import React from "react";
import { withRouter } from "react-router-dom";
import { ENV, MEMBER_BASEURL } from "./config/ApiConfig";
import SignupWizardEnrollment from "./SignupWizardEnrollment.js";
import SignupWizardPayment from "./SignupWizardPayment.js";
import SignupWizardConfirmation from "./SignupWizardConfirmation.js";
import SignupWizardEnrollmentConfirmation from "./SignupWizardEnrollmentConfirmation.js";

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      showEnrollmentConfirmation: false, // TODO: feature flag this in the future
      errorMessage: false,
      firstName: "",
      lastName: "",
      birthDay: "",
      birthMonth: "",
      birthYear: "",
      email: "",
      phone: "",
      zip: "",
      id: "",
      caregiverFirstName: "",
      caregiverLastName: "",
      caregiverEmail: "",
      caregiverPhone: "",
      caregiverRelationship: "",
      caregiverId: "",
      lovedOneFirstName: "",
      lovedOneLastName: "",
      lovedOneBirthDay: "",
      lovedOneBirthMonth: "",
      lovedOneBirthYear: "",
      lovedOnePhone: "",
      lovedOneEmail: "",
      lovedOneZip: "",
      lovedOneReason: "",
      lovedOneId: "",
      inviteCode: "",
      inviteCode2: "",
      caregiverFlow: false,
      wizardStep: "signup",
      showInviteCode: false,
      showInviteCode2: false,
      termsAndPrivacyAccepted: false,
      isValidInviteCode: false,
      throttleEnrollment: false,
      isEnrollmentSubmitting: false,
    };
    if (props.match.params.type === "caregiver") {
      this.state.caregiverFlow = true;
      window.history.replaceState(null, "", "/signup/caregiver");
      document.title = "Duos Sign Up - Caregiver";
    } else {
      window.history.replaceState(null, "", "/signup");
      document.title = "Duos Sign Up";
    }
    window.onbeforeunload = function () {
      return "Data will be lost if you leave the page, are you sure?";
    };

    // Re-routing to newer welcome sign up webpage.
    if (ENV === "prod") {
      window.location.href = "https://app.getduos.com/en/welcome";
    } else {
      window.location.href = "https://app.getduos.xyz/en/welcome";
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "termsAndPrivacyAccepted") {
      this.setState({ [name]: event.target.checked });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleCheckboxChange = (event) => {
    this.setState({ termsAndPrivacyAccepted: event.target.checked });
  };
  handleSelectChange = (event) => {
    this.setState({ caregiverRelationship: event.value });
  };

  validateForm = (_) => {
    // Depending on default browser validation and backend validation response until
    // we add custom client-size validation
    return true;
  };

  getBillingDate = (_) => {
    var date = new Date();
    date.setDate(date.getDate() + 14);
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  };

  applyInviteCode = (_) => {
    if (this.state.inviteCode2.trim() !== "") {
      this.doEnrollment();
    } else {
      this.setState({ isValidInviteCode: false });
    }
  };

  doEnrollment = (_) => {
    const buildErrorsObject = (errorFields) => {
      return (
        errorFields?.reduce(
          (previousErrorFields, errorField) => ({
            ...previousErrorFields,
            [errorField.field]: errorField?.message || true,
          }),
          {}
        ) || {}
      );
    };

    if (this.state.throttleEnrollment || this.state.isEnrollmentSubmitting) return;

    this.setState({ errorMessage: false, throttleEnrollment: true, isEnrollmentSubmitting: true });
    // Prevent double-submitting
    setTimeout(() => {
      this.setState({ throttleEnrollment: false });
    }, 2000);

    const caregiverFlowFields = {
      enrollmentType: "caregiver",
      caregiverFirstName: this.state.caregiverFirstName.trim(),
      caregiverLastName: this.state.caregiverLastName.trim(),
      caregiverEmail: this.state.caregiverEmail === "" ? undefined : this.state.caregiverEmail.trim(),
      caregiverPhone: this.state.caregiverPhone.trim(),
      relationship: this.state.caregiverRelationship.trim(),
      firstName: this.state.lovedOneFirstName.trim(),
      lastName: this.state.lovedOneLastName.trim(),
      birthDay: this.state.lovedOneBirthDay.trim(),
      birthMonth: this.state.lovedOneBirthMonth.trim(),
      birthYear: this.state.lovedOneBirthYear.trim(),
      phone: this.state.lovedOnePhone.trim(),
      email: this.state.lovedOneEmail === "" ? undefined : this.state.lovedOneEmail.trim(),
      zipcode: this.state.lovedOneZip.trim(),
      reason: this.state.lovedOneReason.trim(),
      inviteCode:
        this.state.wizardStep === "signup"
          ? this.state.inviteCode === ""
            ? undefined
            : this.state.inviteCode.trim()
          : this.state.inviteCode2 === ""
          ? undefined
          : this.state.inviteCode2.trim(),
      termsAndPrivacyAccepted: this.state.termsAndPrivacyAccepted,
    };
    const selfFields = {
      enrollmentType: "member",
      firstName: this.state.firstName.trim(),
      lastName: this.state.lastName.trim(),
      birthDay: this.state.birthDay.trim(),
      birthMonth: this.state.birthMonth.trim(),
      birthYear: this.state.birthYear.trim(),
      email: this.state.email === "" ? undefined : this.state.email.trim(),
      phone: this.state.phone.trim(),
      zipcode: this.state.zip.trim(),
      inviteCode:
        this.state.wizardStep === "signup"
          ? this.state.inviteCode === ""
            ? undefined
            : this.state.inviteCode.trim()
          : this.state.inviteCode2 === ""
          ? undefined
          : this.state.inviteCode2.trim(),
      termsAndPrivacyAccepted: this.state.termsAndPrivacyAccepted,
    };
    const requestBody = JSON.stringify(this.state.caregiverFlow ? caregiverFlowFields : selfFields);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: requestBody,
    };
    fetch(MEMBER_BASEURL + "/v1/rest/enroll", requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          switch (response.status) {
            case 400:
              response.json().then((errorFields) => {
                if (this.state.wizardStep === "signup") {
                  const errors = { ...buildErrorsObject(errorFields), validation: true };
                  this.setState({ errors });
                }
              });
              break;
            case 401:
              console.log("Unauthorized");
              break;
            case 404:
              console.log("Not found");
              this.setState({ errors: { serverError: true } });
              break;
            case 409:
              console.log("Conflict");
              response.json().then((errorFields) => {
                if (this.state.wizardStep === "signup") {
                  const errors = { ...buildErrorsObject(errorFields), conflict: true };
                  this.setState({ errors });
                }
              });
              break;
            case 500:
              console.log("Internal server error");
              this.setState({ errors: { serverError: true } });
              break;
            default:
              console.log("Some error occurred error code = " + response.status);
              this.setState({ errors: { serverError: true } });
              break;
          }
          throw Error("Enrollment failed");
        }
      })
      .then((responseData) => {
        this.setState({ errors: {}, isEnrollmentSubmitting: false });
        if (this.state.wizardStep === "signup") {
          //console.log("Enrollment Successful! Response data:");
          if (responseData === "covered") {
            this.setState({ isValidInviteCode: true });
            this.setWizardStep("confirmation");
          } else if (responseData === "enrolled") {
            this.setWizardStep(this.state.showEnrollmentConfirmation ? "enrollment_confirmation" : "payment");
            if (this.state.inviteCode2.trim() !== "") {
              this.setState({ showInviteCode2: true, inviteCode2: this.state.inviteCode });
            }
            window.scrollTo(0, 0);
          } else {
            // TODO: show error message in UI to indicate failed enrollment
            //console.log("Enrollment status returned with failure");
          }
        } else if (this.state.wizardStep === "payment") {
          if (responseData === "covered") {
            this.setState({ isValidInviteCode: true, inviteCode: this.state.inviteCode2 });
          } else {
            this.setState({ inviteCode2: this.state.inviteCode2 });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isEnrollmentSubmitting: false });
      });
  };

  handleEnrollmentSubmit = (event) => {
    event.preventDefault();
    // TODO Form Validation
    if (!this.validateForm()) {
      //console.log("Form validation failed");
      return;
    }
    this.doEnrollment();
  };

  continueToPayment = (_) => {
    this.setWizardStep("payment");
  };

  toggleInviteCode = (_) => {
    this.setState({ showInviteCode: !this.state.showInviteCode });
  };

  toggleInviteCode2 = (_) => {
    this.setState({ showInviteCode2: !this.state.showInviteCode2 });
  };

  errorHandler = (e) => {
    if (this.state.errors[e]) {
      console.log(e);
    }
    return this.state.errors[e] ? { borderColor: "red", filter: "drop-shadow(0px 0px 3px red)" } : {};
  };

  setWizardStep = (s) => {
    this.setState({ wizardStep: s });
    window.scrollTo(0, 0);
    if (s === "signup") {
      this.setCaregiverFlow(this.state.caregiverFlow);
    } else {
      window.history.replaceState(null, "", "/signup/" + s);
      document.title = "Duos Sign Up - " + s.charAt(0).toUpperCase() + s.slice(1);
    }
  };

  setCaregiverFlow = (b) => {
    this.setState({ caregiverFlow: b });
    if (b) {
      window.history.replaceState(null, "", "/signup/caregiver");
      document.title = "Duos Sign Up - Caregiver";
    } else {
      window.history.replaceState(null, "", "/signup");
      document.title = "Duos Sign Up";
    }
  };

  render() {
    return (
      <div>
        <SignupWizardEnrollment
          state={this.state}
          handleChange={this.handleChange}
          handleCheckboxChange={this.handleCheckboxChange}
          handleSelectChange={this.handleSelectChange}
          errorHandler={this.errorHandler}
          setCaregiverFlow={this.setCaregiverFlow}
          handleEnrollment={this.handleEnrollmentSubmit}
          toggleInviteCode={this.toggleInviteCode}
        />
        <SignupWizardPayment
          state={this.state}
          setWizardStep={this.setWizardStep}
          handleChange={this.handleChange}
          removeInviteCode={this.removeInviteCode}
          applyInviteCode={this.applyInviteCode}
          toggleInviteCode2={this.toggleInviteCode2}
          getBillingDate={this.getBillingDate}
        />
        <SignupWizardConfirmation state={this.state} />
        <SignupWizardEnrollmentConfirmation state={this.state} continueToPayment={this.continueToPayment} />
      </div>
    );
  }
}

export default withRouter(Signup);
